import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import Bs4MainDispatch from '../../Bs4MainDispatch';
import Bs4GenericField from './Bs4GenericField';

export default class Bs4AutoText extends Bs4GenericField {
  
  isNativelyClearable () {
    return true;
  }

  getData = (setOptions) => {
    const url = Bs4MainDispatch.getUrlPath(Bs4MainDispatch.WEB_PHP)
    const data = { 
      com: 'Bs4SearchText',
      currFormId: this.props.field.formId,
      inputId: this.props.inputId,
      currCardViewId: null,
      currOptionId: this.props.optionId,
      page: 1,
      start: 0,
      limit: 200,
    }

    const newData = Bs4MainDispatch.getParserParams(data, this.props.bs4KartotekaId)

    const queryUrl = new URLSearchParams();
    queryUrl.append('com', 'Bs4SearchText');
    queryUrl.append('currFormId', newData.currFormId);
    queryUrl.append('_dc', Date.now());
    queryUrl.append('inputId', newData.inputId);      
    queryUrl.append('currCardViewId', newData.currCardViewId);
    queryUrl.append('currOptionId', newData.currOptionId);    
    queryUrl.append('page', newData.page);
    queryUrl.append('start', newData.start);
    queryUrl.append('limit', newData.limit);    

    fetch(url+'?'+queryUrl.toString())
    .then(response => {
      return response.text();
    })
    .then(returnedText => {
      try {
        const returnedJson = JSON.parse(returnedText);
        setOptions(returnedJson.messgs.data.map(object => object.name));        
      } catch (error) {          
        console.log(returnedText, data);
        console.log(error);
      }
    })
    .catch((error) => {
      console.log(error);
    });
  }

  ViewComponentField = () => {
    const formField = this;
    const [inputValue, setInputValue] = React.useState(() => this.getValue() || '');
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    const [options, setOptions] = React.useState([]);    
    this.refFocus = React.useRef();    

    React.useEffect(() => {
      this.getData(setOptions);
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})} 
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setInputValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })                  
    }, [error]);

    const handleInputChange = (event, newInputValue) => {
      this.setValue(newInputValue);
    }

    return (
      <Autocomplete
        readOnly={this.readOnly}
        fullWidth 
        freeSolo
        inputValue={inputValue}
        onInputChange={handleInputChange}
        options={options}
        renderInput={(params) => {
          params.InputProps.disableUnderline = formField.readOnly;
          return (
          <TextField 
            {...params} 
            label={<formField.Bs4Label/>} 
            InputLabelProps={this.props.field.hideLabel ? {sx:{display:'none'}} : null}
            inputRef={this.refFocus} 
            error={error.error} 
            helperText={error.helperText}            
          />
        )}}              
      />        
    );
  }
}